/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shareqrdownload2Inputs */

const en_shareqrdownload2 = /** @type {(inputs: Shareqrdownload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download as PNG`)
};

const de_shareqrdownload2 = /** @type {(inputs: Shareqrdownload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als PNG herunterladen`)
};

/**
* | output |
* | --- |
* | "Download as PNG" |
*
* @param {Shareqrdownload2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareqrdownload2 = /** @type {((inputs?: Shareqrdownload2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareqrdownload2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareqrdownload2(inputs)
	return de_shareqrdownload2(inputs)
});
export { shareqrdownload2 as "shareQrDownload" }